import { use } from 'react';
import { AppShellContext } from './AppShellContext.ts';

export function useAppShell() {
  const context = use(AppShellContext);

  if (!context) {
    throw new Error(`useAppShell needs to be used inside <AppShellProvider>`);
  }

  return context;
}
